import { render, staticRenderFns } from "./FeatureMain.vue?vue&type=template&id=419acbfe&scoped=true&"
import script from "./FeatureMain.vue?vue&type=script&lang=js&"
export * from "./FeatureMain.vue?vue&type=script&lang=js&"
import style0 from "./FeatureMain.vue?vue&type=style&index=0&id=419acbfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419acbfe",
  null
  
)

export default component.exports